<ion-tab-bar
  style="--background: var(--ion-color-primary)"
  slot="bottom"
  mode="md"
  class="menu-mobile"
  *ngIf="isMobile"
>
  <ion-tab-button routerLink="/">
    <img src="/assets/icon/home.svg" alt="home icon" />
    <span>Home</span>
  </ion-tab-button>
  <ion-tab-button routerLink="/search" tab="explore">
    <img src="/assets/icon/search-normal.svg" alt="search icon" />
    <span>Search</span>
  </ion-tab-button>
  <ion-tab-button routerLink="/products" tab="home" class="post-new">
    <img src="/assets/icon/category.svg" alt="category icon" />
    <span>Categories</span>
  </ion-tab-button>
  <ion-tab-button (click)="redirectToBasket()" tab="Basket">
    <span class="cart-badge animate__animated" *ngIf="basketCount">{{
      basketCount
    }}</span>
    <img src="/assets/icon/cart-bottom.svg" alt="basket icon" />
    <span>Basket</span>
  </ion-tab-button>
  <ion-tab-button (click)="openProfile()" tab="profile">
    <div class="image-profile-holder">
      <img src="/assets/icon/profile-circle.svg" alt="user icon" />
    </div>
    <span>Profile</span>
  </ion-tab-button>
</ion-tab-bar>

<footer class="footer">
  <ion-grid>
    <ion-row class="box-container">
      <ion-col>
        <ion-row class="footer-inner">
          <ion-col
            class="footer-col col1"
            sizeXl="3"
            sizeMd="3"
            sizeSm="6"
            sizeXs="12"
          >
            <div class="footer-logo">
              <img src="/assets/img/footer-logo.png" alt="logo" />
            </div>
            <div class="calling">
              <div class="call-icon">
                <img src="/assets/icon/call-calling.svg" alt="calling" />
              </div>
              <div class="call-txt">
                <b><a href="tel:+16479870778">+1 647-987-0778</a></b>
              </div>
            </div>
          </ion-col>
          <ion-col
            class="footer-col col2"
            sizeXl="3"
            sizeMd="3"
            sizeSm="6"
            sizeXs="12"
          >
            <div class="footer-title">
              <h6>Access</h6>
              <ul>
                <li (click)="openProfile()">Register / Login</li>
                <li routerLink="/about">Our Story</li>
                <li routerLink="/products">Products</li>
                <!-- <li>Shipping policy</li> -->
                <li routerLink="/contact">Contact us</li>
                <li routerLink="/return-policy">Warranty and Return Policy</li>
                <li routerLink="/terms-and-conditions">
                  Trade Account Terms and Conditions
                </li>
              </ul>
            </div>
          </ion-col>
          <ion-col
            class="footer-col col3"
            sizeXl="3"
            sizeMd="3"
            sizeSm="6"
            sizeXs="12"
          >
            <div class="footer-title">
              <h6>Categories</h6>
              <ul class="half-col">
                <li routerLink="/products/pull-and-receded-pull/collection">
                  Pull & Receded pull
                </li>
                <li routerLink="/products/knobs/collection">Knobs</li>
                <li routerLink="/products/interior-door-handles/collection">
                  Interior Door Handles
                </li>
                <li routerLink="/products/accessories/collection">
                  Accessories
                </li>
              </ul>
              <ul class="half-col">
                <li routerLink="/products/exterior-door-handles/collection">
                  Exterior Door Handles
                </li>
                <li routerLink="/products/kids-decorative-hard/collection">
                  Kids Decorative Hard
                </li>
                <li routerLink="/products/hinges/collection">Hings</li>
                <li routerLink="/products/appliance-pulls/collection">
                  Appliance pulls
                </li>
              </ul>
            </div>
          </ion-col>
          <ion-col
            class="footer-col col4"
            sizeXl="3"
            sizeMd="3"
            sizeSm="6"
            sizeXs="12"
          >
            <div class="footer-title">
              <h6>Subscribe</h6>
              <p>
                Subscribe to receive inspiration,<br />
                ideas, and news in your inbox.
              </p>
              <div class="newsletter-form">
                <img src="/assets/icon/mail.svg" alt="mail icon" />
                <ion-input
                  (ngModelChange)="email_error = null"
                  [(ngModel)]="email"
                  type="eamil"
                  placeholder="Enter email address"
                ></ion-input>
                <span class="error-newsletter" *ngIf="email_error">{{
                  this.email_error
                }}</span>
                <ion-button
                  [disabled]="newsletterLoader"
                  (click)="SaveNewsletter()"
                  class="newsletter-subscribe"
                  >Subscribe</ion-button
                >
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="footer-bottom">
          <ion-col class="copyrigh-txt">
            <p>© Copyright 2025 ARBAME. All rights reserved.</p>
          </ion-col>
          <ion-col class="social-footer">
            <ul>
              <li>
                <a href="https://www.instagram.com/arbamecorp/" target="_blank" rel="noopener noreferrer" aria-label="ARBAME on Instagram (opens in a new tab)" title="ARBAME on Instagram">
                  <img src="/assets/icon/instagram.svg" alt="" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</footer>
